module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Light-WebS.60468f01.ttf";